// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicy_page__mTZjU","container":"PrivacyPolicy_container__4U2Ua","title":"PrivacyPolicy_title__Sh0IO","section":"PrivacyPolicy_section__ZohOJ"};